import React from 'react';
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button/Button';
import {
  messageSendRequest,
  updateMessageStatusRequest,
  messageStatusAction,
  changeMessageType,
} from '../redux/reducers/message';
import { addTeamLeaderRequest } from '../redux/reducers/addTeamLeader';
import { toggleDeclineInviteReasonPopup } from '../redux/reducers/view';
import { messageContentRequest } from '../redux/reducers/messageContent';
import { messagesListRequest } from '../redux/reducers/messagesList';

import { commonStyles } from '../styles/styles';
import teamIcon from '../assets/team.svg';
import acceptIcon from '../assets/icon_check.svg';
import declineIcon from '../assets/icon_decline.svg';
import { selectRecipient } from '../redux/reducers/connectedUsers';

import { MESSAGE_TYPES } from '../constants';

const LearnerInvitationMessage = ({
  classes,
  messageContent,
  handleAcceptInvite,
  handleDeclineInvite,
}) => (
  <div className={classes.messageWrapper}>
    <Typography className={classes.messageSubject}>- INVITATION -</Typography>
    <img src={teamIcon} alt="Team icon" className={classes.messageContentIcon} />
    <Typography
      className={`${classes.messageContent} ${classes.messageInvitationText}`}
      dangerouslySetInnerHTML={{ __html: messageContent.message.data.message }}
    />
    {messageContent.message.data.status === 'new' && (
      <div className={classes.messageContentButtons}>
        <Button
          onClick={handleAcceptInvite}
          variant="contained"
          className={`${classes.defaultButton} ${classes.button} ${classes.messageContentButton}`}
        >
          ACCEPT
        </Button>
        <Button
          onClick={handleDeclineInvite}
          variant="contained"
          className={`${classes.transparentButton} ${classes.button} ${classes.messageContentButton}
            `}
        >
          DECLINE
        </Button>
      </div>
    )}
    {messageContent.message.data.status === 'decline' && (
      <div className={classes.messageInvitationStatus}>
        <img src={declineIcon} alt="Decline Icon" className={classes.messageInvitationStatusIcon} />
        <Typography component="div">
          <p className={classes.messageInvitationStatusText}>DECLINED</p>
        </Typography>
      </div>
    )}
    {messageContent.message.data.status === 'accept' && (
      <div className={classes.messageInvitationStatus}>
        <img src={acceptIcon} alt="Accepted Icon" className={classes.messageInvitationStatusIcon} />
        <Typography component="div">
          <p className={classes.messageInvitationStatusText}>ACCEPTED</p>
        </Typography>
      </div>
    )}
  </div>
);

const styles = () => ({
  ...commonStyles,
});

const mapStateToProps = state => ({
  connectedUsers: state.connectedUsersReducer,
  messageContent: state.messageContentReducer,
  message: state.messageReducer,
  view: state.viewReducer,
});

const mapDispatchToProps = dispatch => ({
  changeMessageType: typeId => dispatch(changeMessageType(typeId)),
  messageSendRequest: messageContent => dispatch(messageSendRequest(messageContent)),
  updateMessageStatusRequest: value => dispatch(updateMessageStatusRequest(value)),
  messageContentRequest: () => dispatch(messageContentRequest()),
  messageStatusAction: value => dispatch(messageStatusAction(value)),
  selectRecipient: recipientId => dispatch(selectRecipient(recipientId)),
  messagesListRequest: () => dispatch(messagesListRequest()),
  toggleDeclineInviteReasonPopup: value => dispatch(toggleDeclineInviteReasonPopup(value)),
  addTeamLeaderRequest: () => dispatch(addTeamLeaderRequest()),
});

LearnerInvitationMessage.propTypes = {
  classes: PropTypes.instanceOf(Object),
  messageContent: PropTypes.instanceOf(Object),
  handleDeclineInvite: PropTypes.func,
  handleAcceptInvite: PropTypes.func,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('messageSent', 'messageSentChange', null),
  withHandlers({
    handleAcceptInvite: props => () => {
      const {
        changeMessageType,
        selectRecipient,
        messageSendRequest,
        messageSentChange,
        addTeamLeaderRequest,
      } = props;
      changeMessageType(MESSAGE_TYPES.invite.id);
      selectRecipient({ userId: props.messageContent.message.data.sender.id });
      messageSendRequest({
        subject: '- INVITATION -',
        message: '',
        status: 'accept',
      });
      addTeamLeaderRequest();
      messageSentChange(true);
    },
    handleDeclineInvite: props => () => {
      const {
        changeMessageType,
        selectRecipient,
        toggleDeclineInviteReasonPopup,
        messageSentChange,
      } = props;
      changeMessageType(MESSAGE_TYPES.decline.id);
      selectRecipient({ userId: props.messageContent.message.data.sender.id });
      toggleDeclineInviteReasonPopup(true);
      messageSentChange(true);
    },
  }),
  lifecycle({
    componentWillReceiveProps(props) {
      const {
        messageStatusAction,
        updateMessageStatusRequest,
        messageSentChange,
        message,
        messageSent,
      } = props;
      if (message.messageData !== null && message.messageData.success && messageSent) {
        messageStatusAction(message.messageData.status);
        updateMessageStatusRequest(props.messageContent.selectedMessageId);
        messageSentChange(false);
      }
    },
  }),
  withStyles(styles),
)(LearnerInvitationMessage);



// WEBPACK FOOTER //
// ./src/Components/LearnerInvitationMessage.jsx